import { GetGroupMembersParams } from '../../../../types/api/paths/Group';

export type Filters = {
    isActive: string;
    upToDateWithPayments: string;
    subscriptionType: 'all' | 'inscription' | 'unsubscription';
    subscriptionIni: string;
    subscriptionEnd: string;
    trash: boolean;
    name: string;
};

export const filtersToApi = ({
    subscriptionEnd,
    subscriptionIni,
    subscriptionType,
    isActive,
    upToDateWithPayments,
    page,
    rows,
    name,
    trash,
}: Filters & GetGroupMembersParams): GetGroupMembersParams => {
    const base = {
        isActive,
        upToDateWithPayments,
        ...(page && { page }),
        ...(rows && { rows }),
        ...(name && { name }),
        ...(trash && { trash }),
    };

    if (subscriptionType === 'inscription') {
        return {
            ...base,
            inscriptionIni: subscriptionIni,
            inscriptionEnd: subscriptionEnd,
        };
    }

    if (subscriptionType === 'unsubscription') {
        return {
            ...base,
            unsubscriptionIni: subscriptionIni,
            unsubscriptionEnd: subscriptionEnd,
        };
    }

    if (subscriptionType === 'all') {
        return base;
    }

    throw new Error(
        'subscriptionType must be "all", "inscription" or "unsubscription"',
    );
};
